import React, { useContext, useState } from "react";
import { EmpdContext } from "../../../../../Context";
import { createUseStyles } from "react-jss";
import { globe } from "../../../../../Assets/Images";
import ContentWrapper from "../../../../../Components/ContentWrapper";
import { LEADERSHIP_PAGE_CONTENT } from "../../../../../Consts/siteVerbiage";
import { Avatar, Divider, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";

const useStyles = createUseStyles({
  root: {
    width: "100%",
    backgroundImage: `url(${globe})`,
    backgroundColor: "rgba(255,255,255,0.85)",
    backgroundBlendMode: "lighten",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left",
    backgroundSize: "45%",
  },
  rootInner: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  welcomeMessage: {
    display: "flex",
    flexDirection: "column",
    padding: "25px 0px",
    "& h2": {
      margin: 0,
    },
    "& h4": {
      marginTop: 5,
      marginBottom: 0,
    },
  },
  patientData: {
    display: "flex",
    flexDirection: "column",
    padding: "20px 0px",
    textAlign: "right",
    "& h3": {
      margin: 0,
    },
    "& p": {
      marginTop: 5,
      marginBottom: 0,
    },
  },
  subLink: {
    textDecoration: "none",
    padding: "5px 0px",
    color: "#002F6C",
    fontSize: "14px",
  },
});

const recipient = 'globalempd@emory.edu'
const subject = 'Patient Intake Request'
const body = 'Please provide the following information:\n\nName:\n\nPhone Number:\n\nConfirmed diagnosis of EMPD:\n\n\nIf you can answer any of the following, it will help us direct your request more effectively:\n\nDiagnosis date:\n\nPrior treatment: surgery (including Moh’s), radiation, systemic therapy:\n\nCurrent state of disease (NED, active local, active metastatic):'

const useMyContext = () => {
    const context = useContext(EmpdContext)
    if( !context ) {
        throw new Error("No provider found for Context")
    }
    return context
}

const WelcomeBanner = () => {
  const classes = useStyles();
  const context = useMyContext();
  const { userData } = context;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  
  const handleClick = (event:any) => setAnchorEl(event.currentTarget);
  const handleClose = () => {
  	setAnchorEl(null);
  }
  const handleCloseContact = () => {
    window.location.href = `/leadership/#${LEADERSHIP_PAGE_CONTENT.CONTACT.ID}`
  	setAnchorEl(null);
  }
  const handleCloseClinical = () => {
  	window.location.href = `mailto:${recipient}?subject=${encodedSubject}&body=${encodedBody}`
  	setAnchorEl(null);
  }
  const handleCloseLogout = () => {
  	window.location.href = `/logout`
  	setAnchorEl(null);
  }

  const encodedSubject = encodeURIComponent(subject)
  const encodedBody = encodeURIComponent(body)

  return (
    <div className={classes.root}>
      <ContentWrapper>
        <div className={classes.rootInner}>
          <div className={classes.welcomeMessage}>
            <h2>EMPD Patient Dashboard</h2>
            {userData && userData.given_name && (
            <h4>{`Welcome Back, ${userData.given_name} ${userData.family_name}!`}</h4>
            )}
          </div>
          <div className={classes.patientData}>
            {userData && userData.given_name && userData.family_name && (
                <div>
			<Tooltip title="Account settings">
				<IconButton onClick={handleClick} size="large" aria-controls={open ? 'account-menu' : undefined}>
					<Avatar sx={{ 
						width: 48, 
						height: 48, 
						bgcolor: '#152E54', 
						color: '#f6bb60' 
					}}>
						{userData.given_name.charAt(0) + userData.family_name.charAt(0)}
					</Avatar>
				</IconButton>
			</Tooltip>
			<Menu
				anchorEl={anchorEl}
				id="account-menu"
				open={open}
				onClose={handleClose}
				onClick={handleClose}
			>
				<MenuItem sx={{ color: '#152E54' }} onClick={handleCloseContact}>Contact the Team</MenuItem>
				<MenuItem sx={{ color: '#152E54' }} onClick={handleCloseClinical}>Contact the Emory Winship Clinical Team</MenuItem>
				<Divider />
				<MenuItem sx={{ color: '#152E54' }} onClick={handleCloseLogout}>Logout</MenuItem>
			</Menu>
		{/*
                    <h3>{`${userData.given_name} ${userData.family_name}`}</h3>
                    <p>
                         <a
                            key= "Contact the Team"
                            className={classes.subLink}
                            href={`/leadership/#${LEADERSHIP_PAGE_CONTENT.CONTACT.ID}`}
                          >
                             Contact the Team
                          </a>
					</p>
					<p>
                         <a
                            key= "Register with the Clinical Team"
                            className={classes.subLink}
                            href={`mailto:${recipient}?subject=${encodedSubject}&body=${encodedBody}`}
                          >
                             Register with the Clinical Team
                          </a>
                    </p>
					*/}
                </div>
            )}
          </div>
        </div>
      </ContentWrapper>
    </div>
  );
};

export default WelcomeBanner;
